module.exports = "<img width=\"100%\" *ngIf=\"src\" [src]=\"src\">"